import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Voicemail Boxes'
      breadcrumbs={[
        {
          label: 'Phone',
        },
        {
          label: 'Voicemail Boxes',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/voicemail-boxes',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
